"use strict";
exports.__esModule = true;
exports.authHeaderAwsIAM = exports.authHeader = void 0;
var authHeader = function (token) {
    if (!token)
        return {};
    var bearerToken = 'Bearer ' + token;
    return { Authorization: bearerToken };
};
exports.authHeader = authHeader;
var authHeaderAwsIAM = function (token) {
    var _a;
    if (!token)
        return {};
    var bearerToken = 'Bearer ' + token;
    var isDev = process.env.NEXT_PUBLIC_NODE_DEV;
    return _a = {}, _a[isDev ? 'X-Authorization' : 'Authorization'] = bearerToken, _a;
};
exports.authHeaderAwsIAM = authHeaderAwsIAM;
